import { ConsentType } from 'allbirds-analytics';
import { SHOP_IDS } from 'constants/shops';
import Settings from 'utils/Settings';

const SHOP_SETTINGS = {
  [SHOP_IDS.US]: {
    shopID: SHOP_IDS.US,
    environment: Settings.environment,
    oneTrustID: Settings.oneTrustScriptId,
    rudderStackId: Settings.rudderstackAppId,
    defaultScriptStatus: ConsentType.CONSENTED,
  },
  [SHOP_IDS.UK]: {
    shopID: SHOP_IDS.UK,
    environment: Settings.environment,
    oneTrustID: Settings.oneTrustScriptId,
    rudderStackId: Settings.rudderstackAppId,
    defaultScriptStatus: ConsentType.DENIED,
  },
  [SHOP_IDS.EU]: {
    shopID: SHOP_IDS.EU,
    environment: Settings.environment,
    oneTrustID: Settings.oneTrustScriptId,
    rudderStackId: Settings.rudderstackAppId,
    defaultScriptStatus: ConsentType.DENIED,
  },
};

export { SHOP_SETTINGS };
